import React from 'react';

const HomeScreen = () => {
  return (
    <div className="home-screen" style={{ textAlign: 'center', padding: '2rem' }}>
      <h1
        style={{ fontSize: '2rem', marginBottom: '0.5rem', color: 'var(--primary-color)' }}
      >
        Build Federal Resumes with Confidence
      </h1>
      <p
        style={{
          maxWidth: '650px',
          margin: '0 auto',
          lineHeight: '1.6',
          color: 'var(--muted-color)',
        }}
      >
        Enter your profile once, then use One-Shot Resume to generate a grounded federal
        or private resume for a specific job announcement.
      </p>

      <section
        style={{
          maxWidth: '800px',
          margin: '2rem auto',
          textAlign: 'left',
          lineHeight: '1.6',
          color: 'var(--secondary-color)',
        }}
      >
        <h2
          style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary-color)' }}
        >
          Recommended Workflow
        </h2>

        <ol style={{ paddingLeft: '1.25rem' }}>
          <li style={{ marginBottom: '1rem' }}>
            <strong>Build your profile:</strong>
            <ul style={{ listStyleType: 'disc', paddingLeft: '1.25rem', marginTop: '0.5rem' }}>
              <li>Open the menu and select <em>Form</em>.</li>
              <li>Enter work, education, hiring authority, skills, and other resume evidence.</li>
              <li>Select <em>Resume&nbsp;1</em>, click <em>Save</em>, and reload it later if needed.</li>
            </ul>
          </li>

          <li style={{ marginBottom: '1rem' }}>
            <strong>Use One-Shot Resume:</strong>
            <ul style={{ listStyleType: 'disc', paddingLeft: '1.25rem', marginTop: '0.5rem' }}>
              <li>Paste the target job announcement or job description into <em>One-Shot Resume</em>.</li>
              <li>Choose federal or private format before generating.</li>
              <li>Review the generated content before saving or downloading.</li>
            </ul>
          </li>

          <li style={{ marginBottom: '1rem' }}>
            <strong>Use One-Shot Preflight when needed:</strong>
            <ul style={{ listStyleType: 'disc', paddingLeft: '1.25rem', marginTop: '0.5rem' }}>
              <li>
                Open <em>One-Shot Preflight</em> to check whether your profile has enough grounded
                evidence for resume generation.
              </li>
              <li>Fix required items first. Recommended items improve federal detail.</li>
            </ul>
          </li>

          <li style={{ marginBottom: '1rem' }}>
            <strong>Use manual tailoring only for fine-tuning:</strong>
            <ul style={{ listStyleType: 'disc', paddingLeft: '1.25rem', marginTop: '0.5rem' }}>
              <li>Use <em>Tailor Resume</em> if you want to enhance one section at a time.</li>
              <li>This is best for careful edits after the profile already has strong evidence.</li>
              <li>One-Shot is the faster path for creating a full draft.</li>
            </ul>
          </li>

          <li style={{ marginBottom: '1rem' }}>
            <strong>Finalize and download:</strong>
            <ul style={{ listStyleType: 'disc', paddingLeft: '1.25rem', marginTop: '0.5rem' }}>
              <li>Review your preview screen.</li>
              <li>If you need to change something, click <em>Inline Edit</em> in the control panel.</li>
              <li>Once satisfied, download your resume.</li>
            </ul>
          </li>
        </ol>

        <p style={{ marginTop: '1.5rem', fontStyle: 'italic', color: 'var(--muted-color)' }}>
          Pro Tip: One-Shot works best when the profile contains specific, truthful details.
        </p>

        <div
          style={{
            marginTop: '2.5rem',
            paddingTop: '1.5rem',
            borderTop: '1px solid var(--border-color, #e5e7eb)',
            fontSize: '0.85rem',
            color: 'var(--muted-color)',
          }}
        >
          <strong>AI Usage Disclaimer:</strong> This platform uses AI to assist with resume
          suggestions, summaries, and tailoring. AI-generated content is meant to support your
          resume, not replace your judgment. Always review it for accuracy and alignment with
          your actual experience.
        </div>
      </section>
    </div>
  );
};

export default HomeScreen;
